import { createStore } from 'vuex'

import infrastructure from './infrastructure/infrastructure.js'
import dependent from './infrastructure/dependentInfra.js'
import cardAdditionMenu from './infrastructure/cardAdditionMenu.js'
import user from './user/user.js'
import userFinancialData from './user/UserFinancialData.js'
import language from './language/language.js'
import register from './register/register.js'
import profile from './profile/profile.js'
import cards from './cards/cards.js'
import cardRecharge from './cards/cardRecharge.js'
import cardRechargeInfra from './infrastructure/cardRechargeInfra.js'
import financialSummary from './dependent/financialSummary.js'
import foodRestrictionInfra from './infrastructure/foodRestrictionInfra.js'
import foodRestriction from './dependent/foodRestriction.js'
import valueRestrictionInfra from './infrastructure/valueRestrictionInfra.js'
import valueRestriction from './dependent/valueRestriction.js'
import autoRecharge from './dependent/autoRecharge.js'
import menu from './menu/menu.js'
import UserProfileRegister from './user/UserProfileRegister.js'
import menuInfra from './infrastructure/menuInfra.js'
import retailParams from './retailParams/retailParams.js'
import subscriptionServices from './subscriptionServices/subscriptionServices.js'
import invoices from './invoices/invoices.js'
import permission from './permission/permission.js'

export default createStore({
    modules: {
        infrastructure,
        cardAdditionMenu,
        user,
        userFinancialData,
        language,
        register,
        profile,
        cards,
        cardRecharge,
        cardRechargeInfra,
        dependent,
        financialSummary,
        foodRestrictionInfra,
        foodRestriction,
        valueRestrictionInfra,
        valueRestriction,
        autoRecharge,
        menu,
        UserProfileRegister,
        menuInfra,
        retailParams,
        subscriptionServices,
        invoices,
        permission
    }
})
